(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_kjretail-propulsion-addons"] && !Shopify.designMode) return;
  try {
    class KJRetailPropulsionAddons extends HTMLElement {
    connectedCallback() {
      this.groupsElement = this.querySelector('[data-kjr-groups]');
      this.statusElement = this.querySelector('[data-kjr-status]');
      this.recommendationsElement = this.querySelector('[data-kjr-recommendations]');
      this.sectionElement = this.closest('.shopify-section');
      this.currentVariantId = String(this.dataset.initialVariantId || '');
      this.pending = false;

      try {
        this.payload = JSON.parse(this.recommendationsElement?.textContent || '{}');
      } catch (error) {
        this.payload = { variants: {} };
      }

      this.variantUpdateHandler = (event) => {
        const variantId = event.detail?.resource?.id;
        if (!variantId) return;
        this.currentVariantId = String(variantId);
        this.render();
        queueMicrotask(() => this.bindProductForm());
      };
      this.changeHandler = (event) => this.handleSelectionChange(event);
      this.submitHandler = (event) => this.handleSubmit(event);

      this.sectionElement?.addEventListener('variant:update', this.variantUpdateHandler);
      this.addEventListener('change', this.changeHandler);
      window.addEventListener('submit', this.submitHandler, true);
      this.render();
      queueMicrotask(() => this.bindProductForm());
    }

    disconnectedCallback() {
      this.sectionElement?.removeEventListener('variant:update', this.variantUpdateHandler);
      this.removeEventListener('change', this.changeHandler);
      window.removeEventListener('submit', this.submitHandler, true);
      this.productFormComponent?.classList.remove('kjr-addons-selected');
    }

    bindProductForm() {
      const nextComponent = this.sectionElement?.querySelector('product-form-component');
      const nextForm = nextComponent?.querySelector('form[data-type="add-to-cart-form"]');
      if (nextForm === this.productForm) return;
      this.productForm = nextForm || null;
      this.productFormComponent = nextComponent || null;
      this.updateSelectionState();
    }

    render() {
      if (!this.groupsElement) return;
      this.groupsElement.replaceChildren();
      this.setStatus('');
      const variant = this.payload?.variants?.[this.currentVariantId];
      const items = Array.isArray(variant?.items) ? variant.items : [];
      const groupOrder = [
        ['PROPELLER', this.dataset.propellerLabel],
        ['ESC', this.dataset.escLabel],
      ];

      groupOrder.forEach(([role, label]) => {
        const groupItems = items
          .filter((item) => item.role === role)
          .sort((a, b) => Number(a.recommendation_rank) - Number(b.recommendation_rank));
        if (!groupItems.length) return;

        const fieldset = document.createElement('fieldset');
        fieldset.className = 'kjr-propulsion-addons__group';
        const legend = document.createElement('legend');
        legend.className = 'kjr-propulsion-addons__legend';
        legend.textContent = label || role;
        const options = document.createElement('div');
        options.className = 'kjr-propulsion-addons__options';

        groupItems.forEach((item, index) => {
          const row = document.createElement('div');
          row.className = 'kjr-propulsion-addons__option';
          const checkbox = document.createElement('input');
          const inputId = `kjr-addon-${this.currentVariantId}-${role.toLowerCase()}-${index}`;
          checkbox.id = inputId;
          checkbox.type = 'checkbox';
          checkbox.className = 'kjr-propulsion-addons__checkbox';
          checkbox.dataset.kjrAddon = 'true';
          checkbox.dataset.role = role;
          checkbox.dataset.variantId = String(item.variant_id);
          checkbox.dataset.quantityRatio = String(item.quantity_ratio || 1);
          checkbox.setAttribute('aria-label', `${this.dataset.addLabel || 'Add'} ${item.label}`);

          const details = document.createElement('div');
          details.className = 'kjr-propulsion-addons__details';
          const link = document.createElement('a');
          link.className = 'kjr-propulsion-addons__link';
          link.href = item.url;
          link.target = '_blank';
          link.rel = 'noopener';
          link.setAttribute('aria-label', `${item.label} (opens in a new tab)`);
          link.textContent = item.label;
          const evidence = document.createElement('span');
          evidence.className = 'kjr-propulsion-addons__evidence';
          evidence.textContent = item.evidence_kind === 'TEST_REPORT'
            ? this.dataset.testReportLabel
            : this.dataset.matchingGuideLabel;
          details.append(link, evidence);

          const price = document.createElement('span');
          price.className = 'kjr-propulsion-addons__price';
          price.textContent = this.formatMoney(item.price, item.currency);
          row.append(checkbox, details, price);
          options.append(row);
        });

        fieldset.append(legend, options);
        this.groupsElement.append(fieldset);
      });
      this.updateSelectionState();
    }

    formatMoney(value, currency) {
      const amount = Number(value);
      if (!Number.isFinite(amount)) return '';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: currency || 'CAD',
        maximumFractionDigits: 2,
      }).format(amount);
    }

    handleSelectionChange(event) {
      const checkbox = event.target.closest('input[data-kjr-addon]');
      if (!checkbox) return;
      if (checkbox.checked) {
        this.querySelectorAll(`input[data-kjr-addon][data-role="${checkbox.dataset.role}"]`).forEach((input) => {
          if (input !== checkbox) input.checked = false;
        });
      }
      this.setStatus('');
      this.updateSelectionState();
    }

    updateSelectionState() {
      const hasSelection = this.querySelector('input[data-kjr-addon]:checked') !== null;
      this.productFormComponent?.classList.toggle('kjr-addons-selected', hasSelection);
    }

    selectedItems() {
      return Array.from(this.querySelectorAll('input[data-kjr-addon]:checked')).map((input) => ({
        id: Number(input.dataset.variantId),
        quantityRatio: Math.max(1, Number(input.dataset.quantityRatio) || 1),
      }));
    }

    async handleSubmit(event) {
      if (event.target !== this.productForm) return;
      const selected = this.selectedItems();
      if (!selected.length || this.pending || !this.productForm) return;
      if (!this.productForm.checkValidity()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.pending = true;

      const formData = new FormData(this.productForm);
      const motorVariantId = Number(formData.get('id'));
      const motorQuantity = Math.max(1, Number(formData.get('quantity')) || 1);
      const addButton = this.productForm.querySelector('[ref="addToCartButton"]');
      const nativeLiveRegion = this.productFormComponent?.querySelector('[ref="liveRegion"]');
      const wasDisabled = addButton?.disabled || false;
      if (addButton) addButton.disabled = true;
      this.setStatus(this.dataset.addingLabel);
      if (nativeLiveRegion) nativeLiveRegion.textContent = this.dataset.addingLabel;

      const motorItem = { id: motorVariantId, quantity: motorQuantity };
      const properties = {};
      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).length) properties[match[1]] = String(value);
      });
      if (Object.keys(properties).length) motorItem.properties = properties;
      const sellingPlan = formData.get('selling_plan');
      if (sellingPlan) motorItem.selling_plan = Number(sellingPlan);

      const items = [
        motorItem,
        ...selected.map((item) => ({ id: item.id, quantity: motorQuantity * item.quantityRatio })),
      ];
      const sections = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((element) => element.dataset.sectionId)
        .filter((value, index, values) => value && values.indexOf(value) === index);
      const root = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorLabel);

        const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((cartResponse) => cartResponse.json());
        this.querySelectorAll('input[data-kjr-addon]:checked').forEach((input) => {
          input.checked = false;
        });
        this.updateSelectionState();
        this.setStatus(this.dataset.successLabel);
        if (nativeLiveRegion) nativeLiveRegion.textContent = this.dataset.successLabel;
        this.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: result,
            sourceId: 'kjretail-propulsion-addons',
            data: {
              source: 'kjretail-propulsion-addons',
              itemCount: Number(cart.item_count) || 0,
              productId: this.productFormComponent?.dataset.productId,
              sections: result.sections || {},
            },
          },
        }));
      } catch (error) {
        const message = error instanceof Error && error.message ? error.message : this.dataset.errorLabel;
        this.setStatus(message);
        if (nativeLiveRegion) nativeLiveRegion.textContent = message;
        this.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            sourceId: 'kjretail-propulsion-addons',
            data: { message, description: message, errors: null },
          },
        }));
      } finally {
        this.pending = false;
        if (addButton && !wasDisabled) addButton.disabled = false;
      }
    }

    setStatus(message) {
      if (this.statusElement) this.statusElement.textContent = message || '';
    }
  }

  if (!customElements.get('kjretail-propulsion-addons')) {
    customElements.define('kjretail-propulsion-addons', KJRetailPropulsionAddons);
  }
  } catch(e) { console.error(e); }
})();

})();
